// extracted by mini-css-extract-plugin
export default {"root":"Thumbnails-root","cover":"Thumbnails-cover","scroll":"Thumbnails-scroll","item":"Thumbnails-item","active":"Thumbnails-active","srOnly":"Thumbnails-srOnly"};